import React, { useContext, memo } from "react";
import { Box } from "@mui/material";

import useCommunity from "../hooks/useCommunityState.hooks";
import HeatMap from "./chart/HeatMap";
import { useDebounceEffect } from "components/ConnectWallet/ConnectWallet";
import { Loading } from "features/common";

const HeatContainerForOverView = ({ type = "discord", color, context }) => {
  const { fetchCohortData, cohortData, cohortDataLoading } = useCommunity();

  const { dateRange } = useContext(context);
  const [startDate, endDate] = dateRange;

  useDebounceEffect(
    () => {
      fetchCohortData({ type, from: startDate, to: endDate });
    },
    50,
    [startDate, endDate]
  );

  return (
    <Box
      sx={{
        flex: 1,
        height: "250px",
        width: "100%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      {cohortDataLoading ? (
        <Box sx={{ position: "relative", width: "100%", height: "100%" }}>
          <Loading open={true} fullScreen={false} isChart={true} />
        </Box>
      ) : (
        <HeatMap
          chartData={cohortData}
          heatColor={color}
          context={context}
        ></HeatMap>
      )}
    </Box>
  );
};

export default memo(HeatContainerForOverView);
